const _ = require('lodash');
const eventsDtm = require('./events-dtm.constants');

class DtmService {
    constructor($window, $injector, $timeout) {
        this._digitalData = $window.digitalData || {};
        this.$injector = $injector;
        this.$timeout = $timeout;
        this.events = eventsDtm;

        const mergeCopyArrays = function (oldData, newData) { return _.isArray(oldData) ? newData : undefined; };
        this.defaultMerge = (oldData, newData) => _.mergeWith(oldData, newData, mergeCopyArrays);
    }

    push(data, dtmMapperFn) {
        this.$timeout(() => {
            this.mergeData(this._digitalData, data, dtmMapperFn);
        });
    }

    mergeData(dataLayer, data, dtmMapperFn) {
        if (!dtmMapperFn) return;

        // Use merger function that was passed in to merge new data with old data. If no function specified, used default merge
        dataLayer = this.defaultMerge(dataLayer, dtmMapperFn(data));
    }
}

module.exports = DtmService;



// WEBPACK FOOTER //
// ./src/olycommon/analytics/dtm/dtm.service.js